import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChurchService {
  private apiUrl = environment.apiUrl + '/churches/';
  private http = inject(HttpClient);

  get(districtId?: string): Observable<any> {
    let params = new HttpParams();
    if (districtId) params = params.set('district', districtId);
    return this.http.get(this.apiUrl + 'get', { params });
  }

  getById(id: string): Observable<any> {
    return this.http.get(this.apiUrl + 'get/' + id);
  }

  save(churchData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save', churchData);
  }

  update(id: string, churchData: any): Observable<any> {
    return this.http.put(this.apiUrl + 'update/' + id, churchData);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(this.apiUrl + 'delete/' + id);
  }

  importExcel(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(this.apiUrl + 'importExcel', formData);
  }
}
